<template>
  <table
    v-if="items && items.length"
    class="cabinet__table"
  >
    <colgroup>
      <col
        v-if="isLoggedIn"
        width="5%"
      >
      <col width="8%">
      <col width="20%">
      <col width="10%">
      <col width="4%">
      <col width="4%">
      <col
        v-if="isLoggedIn"
        width="8%"
      >
      <col
        v-if="isLoggedIn"
        width="8%"
      >
      <col
        v-if="bestPriceHeader"
        width="16%"
      >
      <col
        v-if="hasRole('supplier') && ((offers && offers[items[0].id]) || (viewOffers && viewOffers[items[0].id]))"
        width="20%"
      >
      <col
        v-if="hasRole('supplier') && offers && offers[items[0].id]"
        width="50px"
      >
    </colgroup>
    <thead class="cabinet__thead">
      <tr>
        <th v-if="isLoggedIn">
          Номер
        </th>
        <th>Наименование материала</th>
        <th>Наименование и местоположение объекта</th>
        <th>Период поставки</th>
        <th class="thead-th--rigth">
          Кол-во
        </th>
        <th v-if="isLoggedIn">
          Ед. изм.
        </th>
        <th
          v-if="isLoggedIn"
          class="thead-th--rigth"
        >
          Базовая цена
        </th>
        <th>НДС</th>
        <th
          v-if="bestPriceHeader"
          class="thead-th--rigth"
        >
          {{ bestPriceHeader }}
        </th>
        <th
          v-if="hasRole('supplier') && ((offers && offers[items[0].id]) || (viewOffers && viewOffers[items[0].id]))"
          class="thead-th--rigth"
        >
          Цена за ед.
        </th>
        <th v-if="hasRole('supplier') && offers && offers[items[0].id]" />
      </tr>
    </thead>
    <tbody class="cabinet__tbody">
      <template
        v-for="item in limitedItems"
        :key="item.id"
      >
        <tr class="cabinet__tbody-row">
          <td
            v-if="isLoggedIn"
            class="cabinet__tbody-column cabinet__tbody-column--number"
          >
            {{ item.requestLineGuid }}
          </td>
          <td class="cabinet__tbody-column cabinet__tbody-column--purchase-name wk__textarea">
            {{ item.title }}
          </td>
          <td class="cabinet__tbody-column cabinet__tbody-column--purchase-name wk__textarea">
            {{ item.object?.name }}
            <br>
            <br>
            {{ item.object?.address }}
            <LocationIcon
              v-if="item.object?.lat"
              :size="20"
            />
          </td>
          <td class="cabinet__tbody-column cabinet__tbody-column--delivery-period">
            {{ dateInterval(item) }}
          </td>
          <td class="cabinet__tbody-column cabinet__tbody-column--nmc">
            <p>{{ quantityFormater(item.quantity) }}</p>
          </td>
          <td
            v-if="isLoggedIn"
            class="cabinet__tbody-column cabinet__tbody-column--unit"
          >
            {{ item.unit }}
          </td>
          <td
            v-if="isLoggedIn"
            class="cabinet__tbody-column cabinet__tbody-column--price"
          >
            <p>{{ currencyFormatter(item.price, item.currency) }}</p>
          </td>
          <!-- td class="cabinet__tbody-column cabinet__tbody-column--price">
          <p v-if="offers && offers[item.id] && offers[item.id].price">
            {{ currencyFormatter(this.offers[item.id].price, item.currency) }}
          </p>
          <p v-else>-</p>
        </td -->
          <td class="cabinet__tbody-column cabinet__tbody-column--unit">
            <p>{{ item.haveVat ? 'с НДС' : 'без НДС' }}</p>
          </td>
          <th
            v-if="bestPriceHeader"
            class="cabinet__tbody-column cabinet__tbody-column--nmc"
          >
            <p>
              {{ formatterToRub(item.bestPrice) }}
            </p>
          </th>
          <td
            v-if="hasRole('supplier') && ((offers && offers[items[0].id]) || (viewOffers && viewOffers[items[0].id]))"
            class="cabinet__tbody-column cabinet__tbody-column--editable-price"
          >
            <InputForm
              v-if="offers && offers[items[0].id]"
              v-model:value="offers[item.id].price"
              input-class="purchases__form-input purchases__form-inputPrice text-right purchases__form-input--green-text"
              type="number"
              is-price
              :disabled="disabled"
              @update:value="calcSum(item.id)"
              @blur="$emit('changeOffer', offers)"
            />

            <div
              v-else-if="viewOffers && viewOffers[items[0].id] && viewOffers[item.id].price"
              class="text-right purchases__form-input--green-text"
            >
              {{ formatterToRub(viewOffers[item.id].price) }}
            </div>
          </td>
          <td
            v-if="hasRole('supplier') && offers && offers[item.id]"
            class="cabinet__tbody-column cabinet__tbody-column--tooltip"
          >
            <TooltipCommon
              v-if="hasRole('customer') && false"
              :menu="tooltipItems"
            />
            <div class="cabinet__tbody-btns">
              <button
                class="cabinet__tbody-btn cabinet__tbody-btn--paper-edit"
                type="button"
                :style="{display: offers[item.id].price && !offers[item.id].showed ? 'block' : 'none'}"
                @click="showOffer(item.id)"
              />
              <button
                class="cabinet__tbody-btn cabinet__tbody-btn--paper-plus"
                type="button"
                :style="{display: !offers[item.id].price && !offers[item.id].showed ? 'block' : 'none'}"
                @click="showOffer(item.id)"
              />
              <button
                class="cabinet__tbody-btn cabinet__tbody-btn--exit"
                type="button"
                :style="{display: offers[item.id]?.showed ? 'block' : 'none'}"
                @click="hideOffer(item.id)"
              />
            </div>
          </td>
        </tr>
        <tr
          v-if="hasRole('supplier') && offers && offers[item.id]"
          class="cabinet__block"
        >
          <td
            class="cabinet__block-td"
            colspan="9"
          >
            <div
              class="cabinet__block-form"
              :style="{display: offers[item.id].showed ? 'block' : 'none'}"
            >
              <h4 class="cabinet__block-title">
                Ваше предложение
              </h4>
              <div class="cabinet__block-subtitle">
                1. Возможен аналог: <b>{{ offers[item.id].haveAnalog ? 'Да' : 'Нет' }}</b>
              </div>
              <div
                v-if="offers[item.id].haveAnalog"
                class="row"
              >
                <div class="col-12 ps-5">
                  <div class="cabinet__block-inputBox">
                    <p class="cabinet__block-inputBox-title">
                      Наименование материала
                    </p>
                    <input
                      v-model="offers[item.id].itemAnalogGuid"
                      :disabled="disabled || !offers[item.id].haveAnalog"
                      class="purchases__form-input purchases__form-input--green-text"
                      type="text"
                      :placeholder="offers[item.id].haveAnalog ? 'Введите наименование' : ''"
                    >
                    <p class="cabinet__block-inputBox-desc">
                      В случае поставки аналога, укажите свое наименование
                    </p>
                  </div>
                </div>
              </div>

              <div class="cabinet__block-subtitle">
                2. Ценовое предложение
              </div>
              <div class="row">
                <div class="col-12 ps-5">
                  <div class="row">
                    <div class="col-2">
                      <div class="cabinet__block-inputBox">
                        <p class="cabinet__block-inputBox-title">
                          Количество
                        </p>
                        <InputForm
                          v-model:value="offers[item.id].quantity"
                          input-class="purchases__form-input text-right"
                          type="number"
                          :disabled="disabled"
                          @update:value="calcSum(item.id)"
                          @blur="$emit('changeOffer', offers)"
                        />
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="cabinet__block-inputBox">
                        <p class="cabinet__block-inputBox-title">
                          Ед.изм.
                        </p>
                        <p class="cabinet__block-inputBox-value">
                          {{ item.unit }}
                        </p>
                      </div>
                    </div>
                    <div class="col-7 offset-1">
                      <div class="cabinet__block-inputBox">
                        <p class="cabinet__block-inputBox-title">
                          Цена за ед.
                        </p>
                        <InputForm
                          v-model:value="offers[item.id].price"
                          placeholder="Введите цену"
                          input-class="purchases__form-input purchases__form-inputPrice text-right purchases__form-input--green-text"
                          type="number"
                          is-price
                          :disabled="disabled"
                          @update:value="calcSum(item.id)"
                          @blur="$emit('changeOffer', offers)"
                        />
                      <!--div class="purchases__hint purchases__hint--margin">
                        Минимальный шаг понижения: 100 000,00 ₽
                      </div-->
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 d-flex">
                      <div class="cabinet__block-inputBox cabinet__block-inputBox--summa">
                        <p class="cabinet__block-inputBox-title">
                          Сумма предложения
                          <span v-if="item.haveVat">(с НДС)</span>
                          <span v-else>(без НДС)</span>
                        </p>
                        <InputForm
                          input-class="purchases__form-input"
                          disabled
                          type="number"
                          is-price
                          :value="offers[item.id].sum"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="offers[item.id].fixCost"
                class="cabinet__block-subtitle"
                style="display: none;"
              >
                Срок фиксации цены
              </div>
              <div
                v-if="offers[item.id].fixCost"
                class="row"
                style="display: none;"
              >
                <div class="col-12 ps-5">
                  <div class="row">
                    <div class="col-6">
                      <InputForm
                        v-model:value="offers[item.id].deliveryDateStart"
                        :disabled="disabled"
                        class="auth__input-block"
                        form-key="form.publicationDate"
                        label="Начало"
                        type="date"
                      />
                    </div>
                    <div class="col-6">
                      <InputForm
                        v-model:value="offers[item.id].deliveryDateEnd"
                        :disabled="disabled"
                        class="auth__input-block"
                        form-key="form.publicationDate"
                        label="Окончание"
                        type="date"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="cabinet__block-subtitle">
                3. Гарантийные обязательства (мес.)
              </div>
              <div class="row">
                <div class="col-6 ps-5">
                  <InputForm
                    v-model:value="offers[item.id].guarantee"
                    placeholder="Введите кол-во месяцев"
                    input-class="purchases__form-input purchases__form-inputPrice text-right purchases__form-input--green-text"
                    type="number"
                    postfix="мес"
                    :disabled="disabled"
                    @update:value="calcSum(item.id)"
                    @blur="$emit('changeOffer', offers)"
                  />
                </div>
                <div class="col-6 ps-3 flex-center">
                  <label class="purchases__checkbox-wrapper purchases__checkbox-wrapper--request">
                    <input
                      v-model="guaranteeForAllFlag"
                      :disabled="disabled"
                      class="purchases__checkbox-input"
                      type="checkbox"
                      name="check"
                    >
                    <span class="purchases__checkbox-span" />
                    <span class="purchases__checkbox-title">
                      Применить ко всему лоту
                    </span>
                  </label>
                </div>
              </div>
              <div
                v-if="guaranteeForAllFlag || deliveryConditionForAllFlag"
                class="row mt-3"
              >
                <div class="col-6 ps-5" />
                <div class="col-5 ps-3 ">
                  <button
                    class="purchases__button ms-4"
                    @click="applyForAll(item.id)"
                  >
                    Применить
                  </button>
                </div>
              </div>

              <div
                v-if="criterionDescription && criterionDescription.guarantee"
                class="cabinet__table__order-hint"
              >
                <HintBlock>
                  <span v-html="criterionDescription.guarantee" />
                </HintBlock>
              </div>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import {
  dateFormat, formatterToRub, currencyFormatter, quantityFormater,
} from '@/utils/helpers';
import { mapGetters, mapState } from 'vuex';
import TooltipCommon from '@/components/details/TooltipCommon.vue';
import LocationIcon from '@/components/icons/LocationIcon';
import InputForm from '@/components/form/input-form';
import HintBlock from '@/components/blocks/HintBlock.vue';

export default {
  name: 'DeliverGoodsTable',
  components: {
    TooltipCommon,
    LocationIcon,
    InputForm,
    HintBlock,
  },
  props: ['items', 'titles', 'pageNumber', 'offers', 'viewOffers', 'disabled', 'criterionDescription'],
  emits: ['changeOffer'],
  data() {
    return {
      guaranteeForAllFlag: false,
      deliveryConditionForAllFlag: false,
      currencyFormatter,
      quantityFormater,
      formatterToRub,
      tooltipItems: ['edit', 'save', 'delete'],
    };
  },
  computed: {
    ...mapState('user', ['isLoggedIn']),
    ...mapGetters({
      hasRole: 'user/hasRole',
    }),

    limitedItems() {
      const startIndex = (this.pageNumber - 1) * 10;
      const endIndex = startIndex + 10;
      return this.items?.slice(startIndex, endIndex);
    },
    numberTitle() {
      return this.getTitle('number');
    },
    materialName() {
      return this.getTitle('title');
    },
    deliveryPeriod() {
      return this.getTitle('deliveryPeriod');
    },
    quantity() {
      return this.getTitle('quantity');
    },
    unit() {
      return this.getTitle('unit');
    },
    price() {
      return this.getTitle('price');
    },
    bestPriceHeader() {
      if (!this.limitedItems.length) {
        return false;
      }

      return this.limitedItems[0].bestPriceHeader || '';
    },
  },
  methods: {
    applyForAll(itemId) {
      if (!this.deliveryConditionForAllFlag && !this.guaranteeForAllFlag) {
        return;
      }
      this.items.forEach((item) => {
        if (this.deliveryConditionForAllFlag) {
          this.offers[item.id].deliveryCondition = this.offers[itemId].deliveryCondition;
        }
        if (this.guaranteeForAllFlag) {
          this.offers[item.id].guarantee = this.offers[itemId].guarantee;
        }
      });
      this.deliveryConditionForAllFlag = false;
      this.guaranteeForAllFlag = false;
    },
    getTitle(name) {
      return (this.titles.find((title) => title.name === name) || {}).title || '';
    },
    showOffer(id) {
      this.offers[id].showed = true;
    },
    hideOffer(id) {
      this.offers[id].showed = false;
    },
    calcSum(id) {
      const offer = this.offers[id];
      offer.sum = offer.price * offer.quantity;
    },
    dateInterval(item) {
      const startDate = dateFormat(item.deliveryPeriodStart);
      const endDate = dateFormat(item.deliveryPeriodEnd);
      return `${startDate}-${endDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.cabinet__table {
  overflow: visible;

  &__order-hint {
    margin-top: 20px;
    margin-left: 38px;
  }
}

.cabinet__tbody-column--price {
  min-width: 110px;
}
.cabinet__tbody-column--editable-price {
  min-width: 136px;
}

.flex-center {
  display: flex;
  align-items: center;
}

.purchases__button {
  width: 200px;
}
</style>
